import { createFileRoute } from "@tanstack/react-router";
import { validateUserAccessToAssistMenu } from "@/lib/assist-guard";

export const Route = createFileRoute("/settings/assist")({
  beforeLoad: ({ context, location }) => {
    const user = context.user;
    validateUserAccessToAssistMenu({ location, user});
  },
});
